"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChatId = void 0;
var crypto_1 = __importDefault(require("crypto"));
function createChatId(props) {
    if (props.activeBuddySession) {
        var unhashed = [
            props.activeBuddySession.userId,
            props.activeBuddySession.matchedUserId,
        ]
            .sort()
            .join('-');
        return "private-".concat(crypto_1.default.createHash('md5').update(unhashed).digest('hex'));
    }
    if (props.groupId) {
        return "group-".concat(props.groupId);
    }
    throw new Error('Chat ID requested without groupId or activeBuddySession');
}
exports.createChatId = createChatId;
